module.exports = __webpack_public_path__ + "img/avatar1.732a8531.jpg";